import React, { useEffect, useState } from "react"
import { Card, CardBody, Spinner } from "reactstrap"
import { StatusSwitch } from "components/AdminAccessCards"
import { getAppConstant, updateAppConstant } from "helpers/backendHelpers/appConstant"

// Master switch for a "free months" offer (1 year: +1 month, 3 years: +3 months).
// `settingKey` is the app-constant flag; when off, the offer is hidden/not applied.
const SubscriptionOfferCard = ({
  settingKey = "subscriptionOfferEnabled",
  title = "Subscription Free Months Offer",
  description = "1 year plan: +1 month free, 3 year plan: +3 months free. When off, the option is hidden while adding a subscription.",
}) => {
  const [enabled, setEnabled] = useState(false)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getAppConstant()
        setEnabled(res?.payload?.[settingKey] === true)
      } catch (err) {
        console.error("Failed to fetch offer setting:", err)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [settingKey])

  const handleToggle = async next => {
    try {
      setSaving(true)
      await updateAppConstant({ constantData: { [settingKey]: next } })
      setEnabled(next)
    } catch (err) {
      console.error("Failed to update offer setting:", err)
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card className="mb-3">
      <CardBody>
        {loading ? (
          <Spinner size="sm" />
        ) : (
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div>
              <h5 className="font-size-16 fw-bold mb-1">{title}</h5>
              <p className="text-muted font-size-13 mb-0">{description}</p>
            </div>
            <div className="d-flex align-items-center gap-2">
              {saving && <Spinner size="sm" />}
              <StatusSwitch checked={enabled} disabled={saving} onChange={handleToggle} />
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default SubscriptionOfferCard
